import { ReportADAExtraParams } from './ReportADAExtraParamsModel.model';

export class ReportGlobalParametersModel {
    TDOCID: string;
    LOCID: string;
    PatientID: string;
    PatientCaseID: string;
    ARClaimID: string;
    ReportADAExtraParams: ReportADAExtraParams;
    currentPerioChartID: string;
    oldPerioChartID: string;
    EnterpriseID: string;
}
